exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{body{background:none!important;background:#fff;background-color:#fff;font-family:Arial,Helvetica,Verdana;width:auto!important;padding:5px!important;font-size:12px}.ddsmoothmenu,.menu,.sidebar_left,.sidebar_right,.submenu,progress{display:none;height:0;width:0}.main_wrapper{margin:0;padding:0}canvas{position:absolute;top:0;left:0}.canvas_wrapper canvas,canvas{border:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"url":false}!./src/css/print.css
// module id = 385
// module chunks = 0